module.exports = __webpack_public_path__ + "static/media/tab_3.4407480d.png";